import React from "react";
import {createRoot} from "react-dom/client";
import MatchingPage from "./pages/MatchingPage";
import MapViewPage from "pages/MapViewPage";
import ReportsPage from "pages/ReportsPage";
import LoginPage from "pages/LoginPage";
import HeatmapPage from "./pages/HeatmapPage";
import LogoutPage from "pages/LogoutPage";
import PasswordChangeFormPage from "pages/PasswordChangeFormPage";
import PasswordChangeDonePage from "pages/PasswordChangeDonePage";

function renderApp() {
    const componentsMap: { [key: string]: React.ComponentType<any> } = {
        "root-matching-page": MatchingPage,
        "root-mapview-page": MapViewPage,
        "root-reports-page": ReportsPage,
        "root-login-page": LoginPage,
        "root-logout-page": LogoutPage,
        "root-password-change-page": PasswordChangeFormPage,
        "root-password-change-done-page": PasswordChangeDonePage,
        "root-heatmap-page": HeatmapPage
    };

    for (const [key, Component] of Object.entries(componentsMap)) {
        const rootElement = document.getElementById(key);
        if (rootElement) {
            const dataset = rootElement.dataset;
            const props: Record<string, any> = {};
            for (const [k, v] of Object.entries(dataset)) {
                props[k] = v;
            }

            const root = createRoot(rootElement);
            root.render(<Component {...props} />);
        }
    }
}

window.addEventListener('DOMContentLoaded', renderApp);